import React from 'react';
import Geosuggest from 'react-geosuggest';
import GeosuggestWrapper from '../../commonComponents/shared/GeoSuggestWrapper';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import Select from '../../commonComponents/util/Select';
import { concatenateGeosuggestLabel } from '../../../lib/utils';

export default class FundReturnAddress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            noSuggestionsError: false,
            invalidAddressError: false,
            addressLabel: this.props.addressLabel || '',
        };

        this.clearNoSuggestions = this.clearNoSuggestions.bind(this);
        this.updateSuggestions = this.updateSuggestions.bind(this);
        this.noSuggestions = this.noSuggestions.bind(this);
        this.onSuggestSelect = this.onSuggestSelect.bind(this);
        this.updateErrors = this.updateErrors.bind(this);
    }

    noSuggestionsError = 'noSuggestionsError';
    invalidAddressError = 'invalidAddressError';

    clearNoSuggestions() {
        if (this.state.noSuggestionsError) this.updateErrors(this.noSuggestionsError, false);
        if (this.state.invalidAddressError) {
            this.updateErrors(this.invalidAddressError, false);
        }
    }

    updateSuggestions(suggestions) {
        if (suggestions.length && this.state.addressLabel) this.clearNoSuggestions();
    }

    noSuggestions() {
        if (this._geoSuggest.props.value !== '') {
            this.updateErrors(this.noSuggestionsError, true);
        }
    }

    onBlur() {
        if((!this.props.address.streetNumber || !this.props.address.street || !this.props.address.city || !this.props.address.country) && this.state.addressLabel && !this.state.noSuggestionsError) {
            this.updateErrors(this.invalidAddressError, true);
        } else if (this.state.invalidAddressError) {
            this.updateErrors(this.invalidAddressError, false);
        }
    }

    updateAddressLabel(label) {
        this.setState({ addressLabel: label || '' });
        if (!label) {
            // When input is cleared, also clear the address in parent
            this.props.updateAddress({
                streetNumber: '',
                street: '',
                city: '',
                state: '',
                zip: '',
                country: '',
                unitType: '',
                apartment: ''
            });
            this.clearNoSuggestions();
        }
    }

    onUnitTypeChange(e) {
        const unitType = e && e.target ? e.target.value : '';
        this.props.updateAddress({
            ...this.props.address,
            unitType
        });
    }

    onApartmentChange(e) {
        const apartment = e && e.target ? e.target.value : e || '';
        this.props.updateAddress({
            ...this.props.address,
            apartment
        });
    }

    onSuggestSelect(suggestion) {
        if (suggestion && suggestion.gmaps && suggestion.gmaps.address_components) {
            let {address_components} = suggestion.gmaps;
            let address = { ...this.props.address };
            address.streetNumber = address_components.find(obj => obj.types.includes('street_number')) ? address_components.find(obj => obj.types.includes('street_number')).long_name : '';
            address.street = address_components.find(obj => obj.types.includes('route')) ? address_components.find(obj => obj.types.includes('route')).long_name : '';
            address.city = (address_components.find(obj => obj.types.includes('locality')) ? address_components.find(obj => obj.types.includes('locality')).long_name : '') || (address_components.find(obj => obj.types.includes('sublocality')) ? address_components.find(obj => obj.types.includes('sublocality')).long_name : '');
            address.state = address_components.find(obj => obj.types.includes('administrative_area_level_1')) ? address_components.find(obj => obj.types.includes('administrative_area_level_1')).long_name : '';
            address.country = address_components.find(obj => obj.types.includes('country')) ? address_components.find(obj => obj.types.includes('country')).long_name : '';
            address.zip = address_components.find(obj => obj.types.includes('postal_code')) ? address_components.find(obj => obj.types.includes('postal_code')).long_name : '';
            if (!address_components.find(obj => obj.types.includes('street_number')) || !address_components.find(obj => obj.types.includes('route'))) {
                this.updateErrors(this.invalidAddressError, true);
                this.setState({addressLabel: concatenateGeosuggestLabel(address, false)});
                this.props.updateAddress({
                    ...this.props.address,
                    streetNumber: '',
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: '',
                    unitType: '',
                    apartment: ''
                });
                this._geoSuggest.blur();
                return;
            }
            else if (this.state.invalidAddressError) {
                this.updateErrors(this.invalidAddressError, false);
            }
            this.setState({addressLabel: concatenateGeosuggestLabel(address, false)});
            this.props.updateAddress(address);
            this._geoSuggest.blur();

        }
    }

    updateErrors(errorName, value) {
        if ((errorName === this.invalidAddressError && !this.state.noSuggestionsError) || errorName === this.noSuggestionsError) {
            this.setState({[errorName]: value});
        }
    }

    render() {
        const validationErr = this.state.noSuggestionsError || this.state.invalidAddressError;
        const addr = this.props.address || {};
        const hasAnyAddressInput = !!(this.state.addressLabel || addr.streetNumber || addr.street || addr.city || addr.country || addr.state || addr.zip || addr.unitType || addr.apartment);
        const requiredErr = this.props.showRequiredError && hasAnyAddressInput && (!addr.streetNumber || !addr.street || !addr.city || !addr.country);

        return (
            <GeosuggestWrapper isIsraeli={false}>
                <div className="modal-row">
                    <div className="column-half">
                        <div className="address-autocomplete">
                            <label className={`input-label ${validationErr || requiredErr ? "error-label" : ""}`}>Return Address</label>
                            <Geosuggest
                                inputClassName={validationErr || requiredErr ? "error-input" : ""}
                                placeholder="Enter Address"
                                queryDelay={0}
                                autoComplete={'on'}
                                ref={el => this._geoSuggest = el}
                                value={this.state.addressLabel}
                                onUpdateSuggests={this.updateSuggestions}
                                onChange={this.updateAddressLabel.bind(this)}
                                onBlur={this.onBlur.bind(this)}
                                initialValue={this.state.addressLabel}
                                onFocus={this.clearNoSuggestions}
                                onSuggestSelect={this.onSuggestSelect}
                                types={['address']}
                                onSuggestNoResults={this.noSuggestions}
                            />
                            <FadeOutErrorMessage show={this.state.noSuggestionsError} message='No suggestions, address cannot be found.'/>
                            <FadeOutErrorMessage show={this.state.invalidAddressError} message='Invalid Address'/>
                        </div>
                    </div>
                    <div className="column-quarter">
                        <label className="input-label input-label-small">Unit Type</label>
                        <Select
                            clearable={true}
                            options={this.props.unitTypes}
                            name="unitType"
                            value={this.props.address.unitType ? this.props.address.unitType : ''}
                            onChange={this.onUnitTypeChange.bind(this)}
                        />
                    </div>
                    <div className="column-quarter" style={{ paddingLeft: 8 }}>
                        <label className="input-label input-label-small">Unit #</label>
                        <input
                            type="text"
                            value={this.props.address.apartment || ''}
                            onChange={this.onApartmentChange.bind(this)}
                            name="apartment"
                        />
                    </div>
                </div>
            </GeosuggestWrapper>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundsCommon/FundReturnAddress.jsx